<div class="appointment-booking">
    <div class="appointment-booking__title" id="afspraak_maken">
        <div class="h4">
            {{ appointment.gebeurtenis.schadeherstel_gebeurtenis_omschrijving }}
        </div>
    </div>

    <div class="appointment-booking__overview">
        <div class="appointment-booking__info" [ngSwitch]="appointment.gebeurtenis.schadeherstel_gebeurtenis_code">
            <p *ngSwitchCase="'GLSH'">
                U kunt hieronder een reparatie-afspraak maken bij een vestiging bij u in de buurt.
            </p>
            <list-flat [numbered]="true" *ngSwitchDefault>
                <list-flat-item>
                    Iedereen die schade meldt (ook als u die niet laat maken), moet even langs bij ABS Autoherstel,
                    zodat we precies het schadebedrag kunnen bepalen
                </list-flat-item>
                <list-flat-item>
                    Nadat de schade is vastgesteld, kunt u bij ABS aangeven of u het daar wil laten repareren of bij uw
                    eigen hersteller
                </list-flat-item>
                <list-flat-item>
                    Als u uw schade daar laat repareren, heeft u trouwens een lager eigen risico
                </list-flat-item>
            </list-flat>
        </div>
        <form [formGroup]="form" class="appointment-booking__form">
            <hr />
            <cyno-field class="appointment-booking__confirmation">
                <cyno-label>Heeft u uw schade laten vaststellen?</cyno-label>
                <cyno-radio
                    [checked]="damage_adopted_indication.value === 'J'"
                    formControlName="schade_vastegesteld_indicatie"
                    value="J"
                >
                    Ja
                </cyno-radio>

                <cyno-radio
                    [checked]="damage_adopted_indication.value === 'N'"
                    formControlName="schade_vastegesteld_indicatie"
                    value="N"
                >
                    Nee
                </cyno-radio>
            </cyno-field>

            <hr />
            <ins-locations-form
                class="appointment-booking__locations"
                [appointment]="appointment"
                [fileSerialNumber]="fileSerialNumber"
                [damageRepairCode]="appointment.gebeurtenis.schadeherstel_gebeurtenis_code"
                formControlName="adres_relatie_id"
                (selectLocation)="onSelectLocation($event)"
            ></ins-locations-form>

            <div
                class="appointment-booking__indication"
                *ngIf="address_relation_id.value !== null && damage_adopted_indication.value !== null"
            >
                <ins-timeslot-form
                    class="appointment-booking__date"
                    *ngIf="damage_adopted_indication.value === 'N'"
                    [appointment]="appointment"
                    [file_serial_number]="fileSerialNumber"
                    [address_relation_id]="form.value.adres_relatie_id"
                    [location]="location"
                    formControlName="indicatie_n"
                ></ins-timeslot-form>

                <ins-date-form
                    class="appointment-booking__date"
                    *ngIf="damage_adopted_indication.value === 'J'"
                    [appointment]="appointment"
                    formControlName="indicatie_j"
                ></ins-date-form>
                <hr />
            </div>
            <ng-container *ngIf="false">
                <div class="appointment-booking__vehicle" *ngIf="replaceableVehicles$ | async as replaceableVehicles">
                    <div class="h4">Reparatie van uw auto</div>
                    <p>Wilt u, na het vaststellen van de schade, bij de reparatie gebruik maken van:</p>
                    <div class="control-input appointment-booking__radio" *ngFor="let vehicle of replaceableVehicles">
                        <input
                            class="radio"
                            formControlName="schadeherstel_soort_vervangend_vervoer_code"
                            id="vehicle-{{ vehicle.content_id }}"
                            type="radio"
                            [value]="vehicle.content_id"
                        />
                        <label for="vehicle-{{ vehicle.content_id }}">{{ vehicle.content_description }}</label>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="notifications">
                <cyno-alert [meldingen]="notifications"></cyno-alert>
                <br />
            </ng-container>

            <div class="form-group">
                <div class="control-submit appointment-booking__submit">
                    <button
                        type="submit"
                        class="btn btn--primary btn--block appointment-booking__submit-button"
                        [disabled]="form.invalid || loading"
                        (click)="onSubmit()"
                    >
                        Maak afspraak
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
